

import { Modal } from 'bootstrap';

export default {
  props: {
    domainWhitelist: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      anchor: null,
      modal: null,
      messageType: null
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
    this.modal = new Modal(document.getElementById('leavingSiteNoticeModal'));
    this.registerClickHandler();
  },
  methods: {
    registerClickHandler() { 
      window.document.addEventListener('click', e => {
        const anchor = e.target.nodeName === 'A' ? e.target : e.target.closest('a');
        if (anchor) {
          try {
            const bypass = anchor.hasAttribute('data-leaving-site-bypass');
            if (bypass) {
              return;
            } else {
              const domain = new URL(anchor.href).hostname;
              if (!domain || domain === new URL(window.location).hostname || this.domainWhitelist.includes(domain)) {
                // Anchor is internal or whitelisted
                return;
              } else {
                // Anchor is external and not whitelisted
                this.interceptAnchor(e, anchor, 'page');
                return;
              }
            }
          } catch {
            // Anchor does not have a valid URL, so don't intervene
            return;
          }
        }
      });
    },
    interceptAnchor(event, anchor, messageType) {
        this.anchor = anchor;
        this.messageType = messageType
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation(); // Prevent GTM from triggering the link click
        this.modal.show();
        return;
    },
    continueClick() {
      this.modal.hide();
    },
    cancelClick() {
      this.modal.hide();
    }
  },
  components: {
  }
};
